import * as React from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Home } from "../pages/Home";
import { ProductDetails } from "../pages/ProductDetails";
import { AddProduct } from "../pages/AddProduct";
import { Manufacturer } from "../pages/Manufacturer";
import { Categories } from "../pages/Categories";
import { EditProduct } from "../pages/EditProduct";
import DmsSetup from "../pages/Integration/DmsSetup";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../redux/reducer/rootReducer";
import { Products } from "../pages/Products";
import ProductManagement from "./../compenents/Integration/Synchronization/ProductManagement";
import Orders from "./../pages/Order/Orders";
import ReInitiateDmsSetup from "../pages/Integration/ReInitiateDmsSetup";
import NewProducts from "./../compenents/New Products/NewProducts";
import { AddPart } from "../compenents/Parts/AddPart";
import Parts from "../pages/Parts/Parts";
import { PartDetails } from "../compenents/Parts/PartDetails";
import { EditPart } from "../compenents/Parts/EditPart";
import ViewSection from "../compenents/products/ViewSection";
import ProductDetailPublicView from "../compenents/products/ProductDetailPublicView";
import { ProductsGallery } from "../pages/ProductsGallery";
import CustomerOrders from "./../pages/Customer/Orders/Orders";
import * as PortalParts from "../pages/ShoppingPortal/PartsPortal";
import { SetupProfilePage } from "../pages/SetupProfile/SetupProfilePage";
import { Customers } from "../pages/Dealer/Customer/Customers";
import CustomerProfilePage from "../pages/Customer/Profile/CustomerProfilePage";
import Quotations from "../pages/Quotation/Quotations";
import UsedProducts from "../pages/Used Products/UsedProducts";
import DmsProductsPage from "../pages/Dms Products/DmsProductsPage";
import { EmbeddedPartsProtal } from "../pages/ShoppingPortal/EmbeddedPartsProtal";
import { PageNotFound } from "../pages/NotFound/PageNotFound";
import AdminOrders from "../pages/Order/AdminOrders";
import PortalSettingRules from "../compenents/Profile/PortalSettingRules";
import { PaymentSettings } from "../compenents/Profile/PaymentSettings";
import { ShoppingPortalPage } from "../compenents/Profile/ShoppingPortalPage";
import { Feature } from "../models/features/Integration/DmsSetup";
import {
  hasFeatureAccess,
  useFeatureFlag,
} from "../services/featurePermissions/featureMatrix";
import DealerSettings from "../compenents/Dealer/DealerSettings";
import Promotions from "../compenents/Integration/Synchronization/Promotions/Promotions";
import FeatureFlags from "../compenents/Dealer/FeatureFlags";
import CustomerLinkPage from "../pages/CustomerLinkPage";

export interface AppRoutesProps {}

export const AppRoutes: React.FunctionComponent<AppRoutesProps> = () => {
  const { role, dmsSetup } = useSelector(
    (state: AppState) => state.authReducer,
  );
  const location = useLocation();
  const navigate = useNavigate();
  const enablePricePromotion = useFeatureFlag("enablePricePromotion");
  React.useEffect(() => {
    if (location.pathname.toLowerCase() === "/login") {
      navigate("/");
    }
  }, []);

  return (
    <>
      <Routes>
        {(role === "Admin" || role === "DataEntry") && (
          <>
            <Route path={"/AddProduct"} element={<AddProduct />}></Route>
            <Route path={"/AddPart"} element={<AddPart />}></Route>

            <Route path={"/EditProduct/:id"} element={<EditProduct />}></Route>
            <Route path={"/EditPart/:id"} element={<EditPart />}></Route>
            <Route
              path={"/ProductDetailView/:productId"}
              element={<ProductDetailPublicView />}
            ></Route>
            {role === "Admin" && (
              <>
                <Route
                  path={"/Manufacturer"}
                  element={<Manufacturer />}
                ></Route>
                <Route path={"/Categories"} element={<Categories />}></Route>
                <Route path={"/Orders"} element={<AdminOrders />}></Route>
                <Route
                  path={"/DealerSettings"}
                  element={<DealerSettings />}
                ></Route>
                <Route
                  path={"/FeatureFlags"}
                  element={<FeatureFlags />}
                ></Route>
              </>
            )}
          </>
        )}
        <Route path={"/CustomerLink"} element={<CustomerLinkPage />}></Route>
        <Route path={"/ProductDetail/:id"} element={<ProductDetails />}></Route>
        <Route path={"/PartDetail/:id"} element={<PartDetails />}></Route>
        <Route path={"/DmsSetup"} element={<DmsSetup />}></Route>
        <Route path={"/AddSite"} element={<DmsSetup />}></Route>
        <Route path={"/ReInitiateDMS"} element={<ReInitiateDmsSetup />}></Route>
        <Route path={"/Sync"} element={<ReInitiateDmsSetup />}></Route>
        {hasFeatureAccess(dmsSetup?.setupType, Feature.VirtualShowroom) && (
          <Route path={"/VirtualShowroom"} element={<NewProducts />}></Route>
        )}
        {hasFeatureAccess(dmsSetup?.setupType, Feature.UsedProducts) && (
          <Route path={"/UsedProducts"} element={<UsedProducts />}></Route>
        )}
        <Route path={"/DmsProducts"} element={<DmsProductsPage />}></Route>
        <Route path={"/ViewSection/:id"} element={<ViewSection />}></Route>

        {/* <Route path={"/SyncProduct"} element={<SyncProduct />}></Route> */}
        <Route path={"/ManageProducts"} element={<ProductManagement />}></Route>

        <Route path={"/Customer/Orders"} element={<CustomerOrders />}></Route>

        <Route path={"/PortalRules"} element={<PortalSettingRules />}></Route>
        <Route path={"/PaymentSetting"} element={<PaymentSettings />}></Route>
        <Route
          path={"/ShoppingPortal"}
          element={<ShoppingPortalPage />}
        ></Route>
        <Route path={"/Products"} element={<Products />}></Route>
        <Route path={"/ProductsGallery"} element={<ProductsGallery />}></Route>
        <Route path={"/Parts"} element={<Parts />}></Route>
        <Route path={"/Orders"} element={<Orders />}></Route>
        <Route
          path={"/Customer/Profile"}
          element={<CustomerProfilePage />}
        ></Route>
        <Route
          path={"/ShoppingPortal/Parts"}
          element={<PortalParts.PartsPortal />}
        ></Route>
        <Route
          path={"/ShoppingPortal/EmbeddedParts"}
          element={<EmbeddedPartsProtal />}
        ></Route>
        <Route path={"/SetupProfile"} element={<SetupProfilePage />}></Route>
        <Route path={"/Dealer/Customers"} element={<Customers />}></Route>
        <Route path={"/Leads"} element={<Quotations />}></Route>
        <Route path={"/"} element={<Home />}></Route>
        <Route
          path={"/invalid-URL"}
          element={<PageNotFound pageNotFound={false} />}
        ></Route>
        <Route
          path={"/Promotions"}
          element={
            enablePricePromotion ? (
              <Promotions />
            ) : (
              <PageNotFound pageNotFound={false} />
            )
          }
        />
        <Route path="*" element={<PageNotFound pageNotFound={true} />} />
      </Routes>
    </>
  );
};
